module.exports = __webpack_public_path__ + "static/media/AI.f72944e7.png";